//
//
//
//
//
//
//
//

// Vendor / external
import Icon from 'vue-awesome/components/Icon'

// Registering them
import 'vue-awesome/icons/tint'
import 'vue-awesome/icons/palette'
import 'vue-awesome/icons/image'
import 'vue-awesome/icons/paint-brush'
import 'vue-awesome/icons/arrow-up'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/arrow-down'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/minus'
import 'vue-awesome/icons/backward'
import 'vue-awesome/icons/plus'

if (typeof window !== 'undefined' && typeof component !== 'undefined' && window.Vue) {
      window.Vue.component('PuiIcon', component.exports)
    } export default {
  components: {
    'v-icon': Icon
  },
  props: {
    icon: {
      type: String,
      default: 'arrow-right'
    },
    color: {
      type: String,
      default: 'grey'
    },
    scale: {
      type: Number,
      default: 1
    }
  }
}
